import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface Fornecedor {
    id: number
    nome: string
    email: string
    telefone: string
    receberEmail: boolean
    receberEmailPedidoExpirado: boolean
    receberEmailPedidoRealizado: boolean
    receberEmailPedidoCancelado: boolean
    receberEmailResumoDiario: boolean
    naoStart?: boolean
}

export interface AtualizarFornecedorPayload {
    nome: string
    email: string
    telefone: string
    receberEmail: boolean
    novaSenha?: string
    receberEmailPedidoExpirado: boolean
    receberEmailPedidoRealizado: boolean
    receberEmailPedidoCancelado: boolean
    receberEmailResumoDiario: boolean
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

const ErroRequisicao = function (error: { message?: string }): string | false {
    if (error.message === "Network Error") return "Verifique sua conexão!"
    if (error.message) return "Erro: " + error.message
    return false
}

export const obterFornecedor = async function (
    authorization: string
): Promise<Fornecedor | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<Fornecedor>>("fornecedor/ObterDadosFornecedor", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: {
                        codErro: 1,
                        mensagem: msg || "Erro desconhecido",
                    } as RespostaRaw<Fornecedor>,
                }
            })

        return tratamentoResponse<Fornecedor>(response, "ObterDadosFornecedor")
    } catch (error) {
        RegistrarLogErro(error, "ObterDadosFornecedor", authorization)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const atualizarFornecedor = async function (
    authorization: string,
    payload: AtualizarFornecedorPayload
): Promise<Fornecedor | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<Fornecedor>>("fornecedor/AtualizarDadosFornecedor", payload, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: {
                        codErro: 1,
                        mensagem: msg || "Erro desconhecido",
                    } as RespostaRaw<Fornecedor>,
                }
            })

        return tratamentoResponse<Fornecedor>(response, "AtualizarDadosFornecedor")
    } catch (error) {
        RegistrarLogErro(error, "AtualizarDadosFornecedor", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
